export default "__VITE_ASSET___uNUsKrT__"